<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="page d-flex flex-row flex-column-fluid">
      <!--begin::Aside-->
      <!--end::Aside-->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" class="header">
          <!--begin::Container-->
          <div
              class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
              id="kt_header_container"
          >
            <!--begin::Page title-->
            <div
                class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
            >
              <!--begin::Heading-->
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">
                Danh sách cron jobs
                <small class="text-muted fs-6 fw-bold ms-1 pt-1"
                >Số lượng {{ $numberFormat(items.length) }} · Tạm dừng {{ countBy('PAUSED') }}</small
                >
              </h1>
              <!--end::Heading-->
            </div>
            <!--end::Page title=-->
            <!--begin::Wrapper-->
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <!--begin::Aside mobile toggle-->
              <div
                  class="btn btn-icon btn-active-icon-primary"
                  id="kt_aside_toggle"
              >
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1 mt-1">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                  >
                    <path
                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3"
                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                        fill="black"
                    />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Aside mobile toggle-->
            </div>
            <!--end::Wrapper-->
          </div>
          <!--end::Container-->
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <div
            class="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <!--begin::Row-->
            <div class="row g-5 g-lg-10">
              <!-- Trạng thái cụm Quartz -->
              <div class="alert d-flex align-items-center p-5 mb-0"
                   :class="cluster.running ? 'alert-success' : 'alert-danger'">
                <i class="bi fs-2 me-4" :class="cluster.running ? 'bi-check-circle-fill text-success' : 'bi-x-octagon-fill text-danger'"></i>
                <div class="d-flex flex-column flex-grow-1">
                  <h4 class="mb-1 text-dark" v-if="cluster.running">Cron đang chạy</h4>
                  <h4 class="mb-1 text-dark" v-else>Không có node nào đang chạy cron</h4>
                  <span v-if="cluster.running">
                    Node:
                    <span v-for="node in aliveNodes" :key="node.instanceId" class="badge badge-light-success me-1">
                      {{ node.instanceId }}
                    </span>
                    · {{ cluster.executingJobs || 0 }} job đang chạy
                  </span>
                  <span v-else>
                    Kiểm tra container <b>backend-fallback</b> (QUARTZ_AUTO_STARTUP=true). Khi không có node, các job sẽ không chạy kể cả bấm "Chạy ngay".
                  </span>
                </div>
                <button class="btn btn-sm btn-light" @click="refresh()" :disabled="loading.page">
                  <span v-if="loading.page" class="spinner-border spinner-border-sm me-1"></span>
                  <i v-else class="bi bi-arrow-clockwise"></i> Làm mới
                </button>
              </div>

              <div class="card card-flush">
                <div class="card-header align-items-center py-5 gap-2 gap-md-5">
                  <div class="card-title">
                    <div class="d-flex align-items-center position-relative my-1">
                      <i class="bi bi-search position-absolute ms-4"></i>
                      <input type="text" v-model="keyword" class="form-control form-control-solid w-250px ps-12"
                             placeholder="Tìm job..."/>
                    </div>
                  </div>
                  <div class="card-toolbar gap-2">
                    <button v-for="f in filters" :key="f.value" class="btn btn-sm"
                            :class="filter === f.value ? 'btn-primary' : 'btn-light'"
                            @click="filter = f.value">
                      {{ f.label }} <span class="badge badge-circle badge-light ms-1">{{ countBy(f.value) }}</span>
                    </button>
                  </div>
                </div>
                <div class="card-body pt-0">
                  <div class="table-responsive">
                    <table class="table align-middle table-row-dashed fs-6 gy-5">
                      <thead>
                      <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                        <th class="min-w-250px">Job</th>
                        <th class="min-w-150px">Lịch chạy</th>
                        <th class="min-w-200px">Thời gian</th>
                        <th class="min-w-100px">Trạng thái</th>
                        <th class="text-end min-w-200px">Hành động</th>
                      </tr>
                      </thead>
                      <tbody class="fw-bold text-gray-600">
                      <tr v-if="!loading.page && filteredItems.length === 0">
                        <td colspan="5" class="text-center text-muted py-10">Không có job nào</td>
                      </tr>
                      <tr v-for="job in filteredItems" :key="job.groupName + '.' + job.jobName">
                        <td>
                          <div class="text-dark fw-bolder">{{ job.jobName }}</div>
                          <div class="text-muted fs-7">{{ job.description || '—' }}</div>
                          <div class="text-muted fs-8" v-if="job.groupName !== 'DEFAULT'">Group: {{ job.groupName }}</div>
                        </td>
                        <td>
                          <code>{{ job.cronExpression || '-' }}</code>
                          <div class="text-muted fs-7">{{ job.cronDescription }}</div>
                        </td>
                        <td class="fs-7">
                          <div>Lần cuối: {{ job.lastFireTime ? $formatDateTime(job.lastFireTime) : '—' }}</div>
                          <div v-if="!job.paused">Tiếp theo: {{ job.nextFireTime ? $formatDateTime(job.nextFireTime) : '—' }}</div>
                          <div v-else class="text-warning">Tiếp theo: đang tạm dừng</div>
                        </td>
                        <td>
                          <span class="badge" :class="statusBadge(job.status).cls">
                            <span v-if="job.status === 'EXECUTING'" class="spinner-grow spinner-grow-sm me-1"></span>
                            {{ statusBadge(job.status).label }}
                          </span>
                        </td>
                        <td class="text-end text-nowrap">
                          <button class="btn btn-sm btn-light-primary me-2"
                                  :disabled="isBusy(job) || job.status === 'EXECUTING'"
                                  @click="runAction(job, 'trigger')"
                                  title="Chạy 1 lần ngay bây giờ, không thay đổi lịch">
                            <span v-if="busy[keyOf(job)] === 'trigger'" class="spinner-border spinner-border-sm me-1"></span>
                            <i v-else class="bi bi-play-fill"></i> Chạy ngay
                          </button>
                          <button v-if="!job.paused" class="btn btn-sm btn-light-warning"
                                  :disabled="isBusy(job)"
                                  @click="runAction(job, 'pause')">
                            <span v-if="busy[keyOf(job)] === 'pause'" class="spinner-border spinner-border-sm me-1"></span>
                            <i v-else class="bi bi-pause-fill"></i> Tạm dừng
                          </button>
                          <button v-else class="btn btn-sm btn-light-success"
                                  :disabled="isBusy(job)"
                                  @click="runAction(job, 'resume')">
                            <span v-if="busy[keyOf(job)] === 'resume'" class="spinner-border spinner-border-sm me-1"></span>
                            <i v-else class="bi bi-arrow-repeat"></i> Tiếp tục
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::Container-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Page-->
  </div>
</template>
<script>
import requestUtil from "@/utils/request-util";

const ACTIONS = {
  trigger: {
    confirm: (job) => `Chạy ngay job "${job.jobName}" 1 lần?\n\n${job.description || ''}\n\nLịch định kỳ và trạng thái tạm dừng (nếu có) giữ nguyên.`,
    done: "Đã gửi lệnh chạy ngay",
  },
  pause: {
    confirm: (job) => `Tạm dừng job "${job.jobName}"?\n\n${job.description || ''}\n\nJob sẽ không chạy theo lịch cho tới khi bấm "Tiếp tục". Lần đang chạy dở (nếu có) vẫn chạy cho xong.`,
    done: "Đã tạm dừng",
  },
  resume: {
    confirm: (job) => `Tiếp tục job "${job.jobName}"?\n\nNếu đã lỡ lịch trong thời gian tạm dừng, job sẽ chạy bù 1 lần ngay, sau đó chạy theo lịch.`,
    done: "Đã tiếp tục",
  },
};

const STATUS = {
  EXECUTING: {label: "Đang chạy", cls: "badge-light-warning"},
  READY: {label: "Sẵn sàng", cls: "badge-light-success"},
  PAUSED: {label: "Tạm dừng", cls: "badge-light-dark"},
  BLOCKED: {label: "Đang chờ", cls: "badge-light-info"},
  ERROR: {label: "Lỗi", cls: "badge-light-danger"},
  NOT_RUNNING: {label: "Không chạy", cls: "badge-light-danger"},
};

export default {
  name: "CronJobs",
  data() {
    return {
      items: [],
      cluster: {running: true, nodes: [], executingJobs: 0},
      keyword: "",
      filter: "ALL",
      filters: [
        {value: "ALL", label: "Tất cả"},
        {value: "READY", label: "Sẵn sàng"},
        {value: "EXECUTING", label: "Đang chạy"},
        {value: "PAUSED", label: "Tạm dừng"},
      ],
      busy: {},
      loading: {
        page: false,
      },
      timer: null,
    };
  },
  computed: {
    aliveNodes() {
      return (this.cluster.nodes || []).filter((n) => n.alive);
    },
    filteredItems() {
      const kw = this.keyword.trim().toLowerCase();
      return this.items.filter((job) => {
        if (this.filter !== "ALL" && job.status !== this.filter) return false;
        if (!kw) return true;
        return (
          job.jobName.toLowerCase().includes(kw) ||
          (job.description || "").toLowerCase().includes(kw)
        );
      });
    },
  },
  mounted() {
    this.refresh();
    // Tự cập nhật trạng thái mỗi 15 giây
    this.timer = setInterval(() => this.refresh(true), 15000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
  methods: {
    keyOf(job) {
      return job.groupName + "." + job.jobName;
    },
    isBusy(job) {
      return !!this.busy[this.keyOf(job)];
    },
    countBy(status) {
      if (status === "ALL") return this.items.length;
      return this.items.filter((j) => j.status === status).length;
    },
    statusBadge(status) {
      return STATUS[status] || {label: status, cls: "badge-light"};
    },
    async refresh(silent = false) {
      if (!silent) this.loading.page = true;
      try {
        await Promise.all([this.fetchItems(), this.fetchCluster()]);
      } finally {
        this.loading.page = false;
      }
    },
    async fetchItems() {
      try {
        const response = await requestUtil.get("/quartz/jobs");
        if (response.status === 200 && Array.isArray(response.data)) {
          this.items = response.data;
        }
      } catch (err) {
        this.notifyError(err, "Không tải được danh sách cron job");
      }
    },
    async fetchCluster() {
      try {
        const response = await requestUtil.get("/quartz/jobs/cluster");
        if (response.status === 200 && response.data) {
          this.cluster = response.data;
        }
      } catch (err) {
        // Backend cũ chưa có API cluster: bỏ qua, không chặn trang
      }
    },
    async runAction(job, action) {
      const cfg = ACTIONS[action];
      if (!window.confirm(cfg.confirm(job))) return;
      const key = this.keyOf(job);
      this.busy = {...this.busy, [key]: action};
      try {
        const response = await requestUtil.post(
          `/quartz/jobs/${encodeURIComponent(job.groupName)}/${encodeURIComponent(job.jobName)}/${action}`
        );
        this.$notify({
          title: cfg.done,
          text: response.data?.message || job.jobName,
          type: "success",
        });
        // Đợi node cron nhận lệnh rồi tải lại trạng thái
        setTimeout(() => this.refresh(true), action === "trigger" ? 1500 : 300);
      } catch (err) {
        this.notifyError(err, "Có lỗi xảy ra");
      } finally {
        const next = {...this.busy};
        delete next[key];
        this.busy = next;
      }
    },
    notifyError(err, title) {
      this.$notify({
        title,
        text: err?.message || "",
        type: "warn",
      });
    },
  },
};
</script>
<style></style>
